module.exports = __webpack_public_path__ + "static/media/skm.f3fa6965.webp";